import bs58 from 'bs58';
import { stringify, v7 } from 'uuid';

export function newId(short: boolean = true): string {
  const bytes = v7(undefined, new Uint8Array(16));
  return short ? bs58.encode(bytes) : stringify(bytes);
}

export function newLongId(): string {
  return newId(false);
}

export function newShortId(): string {
  return newId(true);
}
